import angular from 'angular';

import reportFilterService from './reportFilterService.factory';
import reportSortService from './reportSortService.factory';

export default angular.module('app.dashboard.report.filter', [])
.factory('ReportFilterService', reportFilterService)
.factory('ReportSortService', reportSortService);
